import React, { useState } from "react";
import photoroomImg from "../../assets/images/photoroom1.png";
import "../MainSection/MainSection.css";
import { useNavigate } from "react-router-dom";


export function FormData() {
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const navigate=useNavigate();
 
  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/certificate-download", { state: { firstname, lastname } });
  };

  return (
    <div className="container">
      <div className="Maincontainer mt-5">
        <div className="registerContainer">
          <div className="registerLeft">
            {/* <div>
                      Fill out the form now to join our Vastu with Aromatherapy webinar!
                      </div> */}
            <div className="personImgContainer">
              <img src={photoroomImg} alt="photoroom Img" />
            </div>
          </div>
          <div className="registerRight">
            <div>Fill out the form now to get certificate</div>
            <form onSubmit={handleSubmit}>
              <div className="register-field">
                <label>First Name</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter First Name"
                    value={firstname}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="register-field">
                <label>Last Name</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Last Name"
                    value={lastname}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="btnProceed">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
